import { NavLink, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

function Navbar() {
  const [open, setOpen] = useState(false);

  // sliding underline (desktop only)
  const navRef = useRef(null);
  const location = useLocation();
  const [indicator, setIndicator] = useState({ left: 0, width: 0 });

  const updateIndicator = () => {
    if (!navRef.current) return;

    const active = navRef.current.querySelector(".lp-nav-link.active");
    if (!active) return;

    const navRect = navRef.current.getBoundingClientRect();
    const linkRect = active.getBoundingClientRect();

    setIndicator({
      left: linkRect.left - navRect.left,
      width: linkRect.width,
    });
  };

  // close menu + update indicator after route change
  useEffect(() => {
    setOpen(false);
    setTimeout(updateIndicator, 80);
  }, [location.pathname]);

  // update on resize
  useEffect(() => {
    window.addEventListener("resize", updateIndicator);
    return () => window.removeEventListener("resize", updateIndicator);
  }, []);

  return (
    <nav className="lp-navbar">
      <div
        className={`lp-hamburger ${open ? "active" : ""}`}
        onClick={() => setOpen(!open)}
        role="button"
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className="lp-logo-wrap">
        <img src="/lappy-logo-navbar.png" alt="Lappy Laptops" className="lp-nav-logo" />
      </div>

      <div className={`lp-nav-links ${open ? "show" : ""}`} ref={navRef}>
        <NavLink
          to="/"
          className={({ isActive }) => "lp-nav-link" + (isActive ? " active" : "")}
          onClick={() => setOpen(false)}
        >
          Home
        </NavLink>

        <NavLink
          to="/products"
          className={({ isActive }) => "lp-nav-link" + (isActive ? " active" : "")}
          onClick={() => setOpen(false)}
        >
          Products
        </NavLink>

        <NavLink
          to="/services"
          className={({ isActive }) => "lp-nav-link" + (isActive ? " active" : "")}
          onClick={() => setOpen(false)}
        >
          Services
        </NavLink>

        <NavLink
          to="/about"
          className={({ isActive }) => "lp-nav-link" + (isActive ? " active" : "")}
          onClick={() => setOpen(false)}
        >
          About
        </NavLink>

        <NavLink
          to="/contact"
          className={({ isActive }) => "lp-nav-link" + (isActive ? " active" : "")}
          onClick={() => setOpen(false)}
        >
          Contact
        </NavLink>

        <span
          className="lp-nav-indicator"
          style={{ left: indicator.left, width: indicator.width }}
        />
      </div>

      <div
        className={`lp-drawer-overlay ${open ? "show" : ""}`}
        onClick={() => setOpen(false)}
      />
    </nav>
  );
}

export default Navbar;
